import { render, staticRenderFns } from "./StepQuestionsGroup.vue?vue&type=template&id=056410bd&scoped=true"
import script from "./StepQuestionsGroup.vue?vue&type=script&lang=js"
export * from "./StepQuestionsGroup.vue?vue&type=script&lang=js"
import style0 from "./StepQuestionsGroup.vue?vue&type=style&index=0&id=056410bd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "056410bd",
  null
  
)

export default component.exports